import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Store } from '@ngrx/store';

import { GopherBuddyAppState } from '../../../+state/app.state';
import { GBMessages } from '../../../../background-service-worker/services/message-handler/message-handler.interfaces';
import { MaterialModule } from '../../material/material.module.ts/material/material.module';
import { UiService } from '../../services/ui.service';

@Component({
  selector: 'app-gb-help',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  providers: [UiService],
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss'],
})
export class HelpComponent {
  constructor(private appStore: Store<GopherBuddyAppState>) {}

  public openFAQ = () => {
    chrome.runtime.sendMessage(GBMessages.OPEN_FAQ, () => {});
  };
}
